import { useTemplate } from "@/lib/helpers/template"
import classNames from "classnames"
import Block from "@/components/wrappers/block"
import Blocks from "@/components/Blocks"
import BlockHeader from "@/common/partials/block-header/block-header"
import styles from "./accordion.module.css"

export default function Accordion({ block, settings }) {
  const template = useTemplate()
  const { attrs, innerBlocks } = block
  const { classList, bgColor, blockGap, heading, text } = attrs

  if (innerBlocks.length === 0) {
    return null
  }

  const defaultGap = template === "article" ? "content" : "normal"
  const width = template === "article" ? "column" : "bleed"
  const gap =
    template === "article" && blockGap === "normal"
      ? "content"
      : settings?.blockGap ?? blockGap ?? defaultGap
  const wrapperColor = template !== "article" ? "bg-color-" + bgColor : null
  const innerColor = template === "article" ? "bg-color-" + bgColor : null

  const itemSettings = { "theme/accordion-item": settings?.item }

  return (
    <Block
      block={block}
      width={width}
      gap={gap}
      className={classNames(styles.wrapper, wrapperColor, {
        "is-faq": settings?.isFaq,
        "is-article": template === "article",
        "is-event": template === "event",
        "toggle-has-accent-color":
          classList && classList.includes("toggle-has-accent-color")
      })}>
      <div
        className={classNames("inner-wrapper", innerColor, {
          "is-transparent": bgColor === "transparent"
        })}>
        <BlockHeader
          align="inner-column"
          heading={heading}
          text={text}
          className={"template-" + template}
        />
        <Blocks blocks={innerBlocks} settings={itemSettings} />
      </div>
    </Block>
  )
}
